import React from 'react';
import { ElementRenderer } from "../index.js";
import { FormLayout } from "../../../formLayout/FormLayout.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function CustomFormLayout({
  element,
  isLoading,
  control,
  isFormDisabled,
  useSmallFields
}) {
  return /*#__PURE__*/_jsx(FormLayout, {
    ...element.componentProps,
    children: element.componentProps.children.map((child, index) => /*#__PURE__*/_jsx(ElementRenderer, {
      element: child,
      loading: isLoading,
      control,
      isFormDisabled,
      isLoading,
      useSmallFields
    }, index))
  });
}